import 'svelte/internal/disclose-version';

Field[$.FILENAME] = 'src/components/Field.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<span class="req svelte-1wzaqos" aria-hidden="true">*</span>`), Field[$.FILENAME], [[25, 25]]);
var root_1 = $.add_locations($.from_html(`<option> </option>`), Field[$.FILENAME], [[31, 8]]);
var root_2 = $.add_locations($.from_html(`<select class="svelte-1wzaqos"></select>`), Field[$.FILENAME], [[29, 4]]);
var root_3 = $.add_locations($.from_html(`<textarea class="svelte-1wzaqos"></textarea>`), Field[$.FILENAME], [[35, 4]]);
var root_4 = $.add_locations($.from_html(`<input class="svelte-1wzaqos"/>`), Field[$.FILENAME], [[37, 4]]);
var root_5 = $.add_locations($.from_html(`<p class="error svelte-1wzaqos"> </p>`), Field[$.FILENAME], [[41, 4]]);
var root_6 = $.add_locations($.from_html(`<p class="hint svelte-1wzaqos"> </p>`), Field[$.FILENAME], [[43, 4]]);
var root_7 = $.add_locations($.from_html(`<div><label class="svelte-1wzaqos"> <!></label> <!> <!></div>`), Field[$.FILENAME], [[23, 0, [[24, 2]]]]);

const $$css = {
	hash: 'svelte-1wzaqos',
	code: '\n  .field.svelte-1wzaqos { display: flex; flex-direction: column; gap: 6px; }\n  label.svelte-1wzaqos { font-size: 0.85rem; font-weight: 600; color: var(--ink-soft); }\n  .req.svelte-1wzaqos { color: var(--accent); margin-left: 3px; }\n\n  input.svelte-1wzaqos, textarea.svelte-1wzaqos, select.svelte-1wzaqos {\n    width: 100%;\n    background: var(--card);\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-sm);\n    padding: 11px 13px;\n    font-size: 0.95rem;\n    outline: none;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  }\n  textarea.svelte-1wzaqos { resize: vertical; line-height: 1.5; font-family: inherit; }\n  input.svelte-1wzaqos:focus, textarea.svelte-1wzaqos:focus, select.svelte-1wzaqos:focus {\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px var(--accent-soft);\n  }\n  .has-error.svelte-1wzaqos input:where(.svelte-1wzaqos), .has-error.svelte-1wzaqos textarea:where(.svelte-1wzaqos), .has-error.svelte-1wzaqos select:where(.svelte-1wzaqos) { border-color: var(--accent); }\n\n  .hint.svelte-1wzaqos, .error.svelte-1wzaqos { margin: 0; font-size: 0.79rem; }\n  .hint.svelte-1wzaqos { color: var(--ink-faint); }\n  .error.svelte-1wzaqos { color: var(--accent-dark); font-weight: 500; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Field($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Field);
	$.append_styles($$anchor, $$css);

	let value = $.prop($$props, 'value', 15, ""),
		type = $.prop($$props, 'type', 3, "text"),
		name = $.prop($$props, 'name', 3, ""),
		placeholder = $.prop($$props, 'placeholder', 3, ""),
		required = $.prop($$props, 'required', 3, false),
		hint = $.prop($$props, 'hint', 3, ""),
		error = $.prop($$props, 'error', 3, ""),
		rows = $.prop($$props, 'rows', 3, 0),
		options = $.prop($$props, 'options', 3, null),
		autocomplete = $.prop($$props, 'autocomplete', 3, "off"),
		inputmode = $.prop($$props, 'inputmode', 3, null),
		min = $.prop($$props, 'min', 3, null),
		max = $.prop($$props, 'max', 3, null),
		step = $.prop($$props, 'step', 3, null);

	const id = `field-${name() || $$props.label}`.toLowerCase().replace(/[^a-z0-9]+/g, "-");
	var $$exports = { ...$.legacy_api() };
	var div = root_7();
	let classes;
	var label_1 = $.child(div);
	var text = $.child(label_1, true);
	var node = $.sibling(text);

	{
		var consequent = ($$anchor) => {
			var span = root();

			$.append($$anchor, span);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (required()) $$render(consequent);
			}),
			'if',
			Field,
			25,
			11
		);
	}

	$.reset(label_1);

	var node_1 = $.sibling(label_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			var select = root_2();

			$.add_svelte_meta(
				() => $.each(select, 21, options, (option) => option.value ?? option, ($$anchor, option) => {
					var option_1 = root_1();
					var text_1 = $.child(option_1, true);

					$.reset(option_1);

					var option_1_value = {};

					$.template_effect(() => {
						$.set_text(text_1, $.get(option).label ?? $.get(option));

						if (option_1_value !== (option_1_value = $.get(option).value ?? $.get(option))) {
							option_1.value = (option_1.__value = $.get(option).value ?? $.get(option)) ?? '';
						}
					});

					$.append($$anchor, option_1);
				}),
				'each',
				Field,
				30,
				6
			);

			$.reset(select);

			$.template_effect(() => {
				$.set_attribute(select, 'id', id);
				$.set_attribute(select, 'name', name());
				select.required = required();
			});

			$.bind_select_value(
				select,
				function get() {
					return value();
				},
				function set($$value) {
					value($$value);
				}
			);

			$.append($$anchor, select);
		};

		var consequent_2 = ($$anchor) => {
			var textarea = root_3();

			$.remove_textarea_child(textarea);

			$.template_effect(() => {
				$.set_attribute(textarea, 'id', id);
				$.set_attribute(textarea, 'name', name());
				$.set_attribute(textarea, 'rows', rows());
				$.set_attribute(textarea, 'placeholder', placeholder());
				textarea.required = required();
			});

			$.bind_value(
				textarea,
				function get() {
					return value();
				},
				function set($$value) {
					value($$value);
				}
			);

			$.append($$anchor, textarea);
		};

		var alternate = ($$anchor) => {
			var input = root_4();

			$.remove_input_defaults(input);

			$.template_effect(() => {
				$.set_attribute(input, 'id', id);
				$.set_attribute(input, 'name', name());
				$.set_attribute(input, 'type', type());
				$.set_attribute(input, 'placeholder', placeholder());
				input.required = required();
				$.set_attribute(input, 'autocomplete', autocomplete());
				$.set_attribute(input, 'inputmode', inputmode());
				$.set_attribute(input, 'min', min());
				$.set_attribute(input, 'max', max());
				$.set_attribute(input, 'step', step());
			});

			$.bind_value(
				input,
				function get() {
					return value();
				},
				function set($$value) {
					value($$value);
				}
			);

			$.append($$anchor, input);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if (options()) $$render(consequent_1); else if (rows() > 0) $$render(consequent_2, 1); else $$render(alternate, -1);
			}),
			'if',
			Field,
			28,
			2
		);
	}

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent_3 = ($$anchor) => {
			var p = root_5();
			var text_2 = $.child(p, true);

			$.reset(p);
			$.template_effect(() => $.set_text(text_2, error()));
			$.append($$anchor, p);
		};

		var consequent_4 = ($$anchor) => {
			var p_1 = root_6();
			var text_3 = $.child(p_1, true);

			$.reset(p_1);
			$.template_effect(() => $.set_text(text_3, hint()));
			$.append($$anchor, p_1);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if (error()) $$render(consequent_3); else if (hint()) $$render(consequent_4, 1);
			}),
			'if',
			Field,
			40,
			2
		);
	}

	$.reset(div);

	$.template_effect(() => {
		classes = $.set_class(div, 1, 'field svelte-1wzaqos', null, classes, { 'has-error': !!error() });
		$.set_attribute(label_1, 'for', id);
		$.set_text(text, $$props.label);
	});

	$.append($$anchor, div);

	return $.pop($$exports);
}